import React from 'react'
import { Helmet } from 'react-helmet'

import { EuiSpacer, EuiTitle } from '@elastic/eui'

import history from 'services/HistoryService'

import CommercialUploader from '../CommercialUploader'

const UploadStep: React.FC = () => {
  const gotoStart = () => {
    history.push('/campaigns/tv/public/start')
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Upload Commercial</title>
      </Helmet>
      <EuiTitle size='s'>
        <h3>Upload Commercial</h3>
      </EuiTitle>
      <EuiSpacer size='m' />
      <CommercialUploader onBackClick={gotoStart} />
    </React.Fragment>
  )
}

export default UploadStep
